
// // client/src/components/Integrations.jsx
// // ========================================================================
// // Integrations Component - UPDATED WITH TIKTOK
// // Add this to your existing Integrations.jsx file
// // ========================================================================
// // Instructions: Add the TikTok imports and button to your existing component

// import React, { useEffect, useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import AppFooter from './AppFooter';
// import { FaTimes, FaArrowLeft, FaHome } from 'react-icons/fa';
// import { ensureFbSdk } from '../utils/ensureFbSdk';
// import YouTubeConnectButton from './YouTubeConnectButton';
// // ===== ADD THESE IMPORTS =====
// import TikTokConnectButton from './TikTokConnectButton';
// import TikTokMetrics from './TikTokMetrics';

// const FB_APP_ID = '748347668239935';
// const FB_VERSION = 'v24.0';

// function Integrations() {
//   const [statusMessage, setStatusMessage] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [fbStatus, setFbStatus] = useState(null);
//   // ===== ADD THIS STATE FOR TIKTOK =====
//   const [showTikTokMetrics, setShowTikTokMetrics] = useState(false);

//   const navigate = useNavigate();
//   const { tenant } = useParams();
//   const baseUrl = process.env.REACT_APP_BASE_URL || window.location.origin || 'http://localhost:5000';

//   const getTenantId = () =>
//     Number(tenant) || Number(localStorage.getItem('tenantId')) || 1;

//   const handleDashboard = () => navigate(`/${getTenantId()}/dashboard`);

//   // Initialize Facebook SDK
//   useEffect(() => {
//     (async () => {
//       try {
//         const FB = await ensureFbSdk(FB_APP_ID, FB_VERSION);
//         FB.getLoginStatus((response) => setFbStatus(response));
//       } catch (err) {
//         console.error('Failed to init FB SDK', err);
//       }
//     })();
//   }, []);

//   // ========== Twitter Connection ==========
//   const connectToTwitter = async () => {
//     try {
//       setLoading(true);
//       const redirectUrl = `${baseUrl}/api/integrations/twitter/connect/${getTenantId()}`;
//       window.location.href = redirectUrl;
//     } catch (err) {
//       console.error('❌ Twitter integration failed:', err);
//       setStatusMessage('Error starting Twitter OAuth flow. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ========== Facebook Connection ==========
//   async function peekEligibility(tenantId) {
//     try {
//       const peekRes = await fetch(`${baseUrl}/api/integrations/facebook/peek?tenantId=${tenantId}`);
//       const peek = await peekRes.json();
//       const pageCount = Array.isArray(peek?.pages) ? peek.pages.length : 0;

//       setStatusMessage(
//         pageCount > 0
//           ? '✅ Facebook/Instagram connected'
//           : 'Connected to Facebook, but no eligible Pages found. Ensure your IG is Business/Creator, linked to a Page, and you have Full control.'
//       );
//     } catch (e) {
//       console.error('peek error', e);
//       setStatusMessage('Connected, but could not verify eligibility. Check console.');
//     }
//   }

//   const connectViaSdk = async () => {
//     try {
//       const FB = await ensureFbSdk(FB_APP_ID, FB_VERSION);

//       if (!FB || typeof FB.login !== 'function') {
//         throw new Error('FB SDK not ready (missing FB.login)');
//       }

//       FB.login(
//         function (resp) {
//           if (!resp || resp.status !== 'connected' || !resp.authResponse) {
//             setStatusMessage('Facebook login was cancelled or not authorized.');
//             return;
//           }

//           (async () => {
//             try {
//               const tenantId = getTenantId();
//               const accessToken = resp.authResponse.accessToken;

//               const r = await fetch(`${baseUrl}/api/integrations/facebook/token-login`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: 'include',
//                 body: JSON.stringify({ tenantId, accessToken }),
//               });
//               const j = await r.json();

//               if (!r.ok || !j.success) {
//                 setStatusMessage(`❌ ${j.error || 'Facebook login failed'}`);
//                 return;
//               }

//               const immediateEligible = Array.isArray(j.pages)
//                 ? j.pages.some(p => p.igUserId && (p.hasPageToken ?? true))
//                 : false;

//               if (immediateEligible) {
//                 setStatusMessage('✅ Facebook/Instagram connected');
//               } else {
//                 await peekEligibility(tenantId);
//               }
//             } catch (e) {
//               console.error('token-login error', e);
//               setStatusMessage('❌ Failed to complete Facebook login.');
//             }
//           })();
//         },
//         {
//           scope: [
//             'public_profile',
//             'email',
//             'pages_show_list',
//             'pages_read_engagement',
//             'pages_manage_metadata',
//             'instagram_basic',
//             'instagram_manage_comments',
//             'instagram_manage_insights',
//             'instagram_content_publish',
//             'business_management'
//           ].join(','),
//           auth_type: 'rerequest',
//           return_scopes: true,
//         }
//       );
//     } catch (err) {
//       console.error('FB.login failed to start', err);
//       setStatusMessage('❌ Could not start Facebook login. Check SDK settings.');
//     }
//   };

//   const connectInstagram = (e) => {
//     e?.preventDefault();
//     const tenantId = getTenantId();
//     const url = `${baseUrl}/api/integrations/facebook/login?tenantId=${encodeURIComponent(tenantId)}`;
//     const w = window.open(
//       url,
//       'fb_ig_oauth',
//       'width=700,height=800,menubar=no,toolbar=no,status=no'
//     );

//     if (!w) {
//       setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
//       return;
//     }
//     w.focus?.();

//     let closedPoll = null;

//     const cleanup = () => {
//       window.removeEventListener('message', onMsg);
//       if (closedPoll) {
//         clearInterval(closedPoll);
//         closedPoll = null;
//       }
//     };

//     const onMsg = async (ev) => {
//       if (!ev?.data) return;

//       if (ev.data.type === 'FB_OK') {
//         cleanup();
//         await peekEligibility(tenantId);
//       } else if (ev.data.type === 'FB_ERR') {
//         cleanup();
//         const msg = ev.data.error_message || ev.data.error || 'Facebook login failed';
//         setStatusMessage(`❌ ${msg}`);
//         console.error('FB_ERR from popup:', ev.data);
//       }
//     };

//     window.addEventListener('message', onMsg);

//     closedPoll = setInterval(async () => {
//       if (w.closed) {
//         cleanup();
//         await peekEligibility(tenantId);
//       }
//     }, 800);
//   };

//   // ========== LinkedIn Connection ==========
//   const connectLinkedIn = () => {
//     const tenantId = getTenantId();
//     const url = `${baseUrl}/api/integrations/linkedin/login?tenantId=${encodeURIComponent(tenantId)}`;
    
//     const w = window.open(
//       url,
//       'li_oauth',
//       'width=700,height=800,menubar=no,toolbar=no,status=no'
//     );
    
//     if (!w) {
//       setStatusMessage('❌ Popup was blocked. Please allow popups for on-screen.app.');
//       return;
//     }
    
//     w.focus?.();

//     const onMsg = (ev) => {
//       if (!ev?.data) return;
      
//       if (ev.data.type === 'LI_OK') {
//         window.removeEventListener('message', onMsg);
//         setStatusMessage('✅ LinkedIn connected');
//         console.log('[LinkedIn] Connection successful for tenant:', ev.data.tenantId);
//       } else if (ev.data.type === 'LI_ERR') {
//         window.removeEventListener('message', onMsg);
//         const msg = ev.data.error_description || ev.data.error || 'LinkedIn login failed';
//         setStatusMessage(`❌ LinkedIn: ${msg}`);
//         console.error('[LinkedIn] Connection error:', ev.data);
//       }
//     };
    
//     window.addEventListener('message', onMsg);
//   };

//   // ========== Bluesky Connection ==========
//   const connectBluesky = () => {
//     const meTenant = getTenantId();
//     const url = `${baseUrl}/api/integrations/bluesky/login?tenantId=${encodeURIComponent(meTenant)}`;
//     const w = window.open(
//       url,
//       'bsky_oauth',
//       'width=700,height=800,menubar=no,toolbar=no,status=no'
//     );
//     if (!w) {
//       setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
//       return;
//     }
//     w.focus?.();

//     const onMsg = (ev) => {
//       if (!ev?.data) return;
//       if (ev.data.type === 'BSKY_OK') {
//         window.removeEventListener('message', onMsg);
//         setStatusMessage('✅ Bluesky connected');
//       } else if (ev.data.type === 'BSKY_ERR') {
//         window.removeEventListener('message', onMsg);
//         const msg = ev.data.error_message || ev.data.error || 'Bluesky login failed';
//         setStatusMessage(`❌ ${msg}`);
//         console.error('BSKY_ERR from popup:', ev.data);
//       }
//     };
//     window.addEventListener('message', onMsg);
//   };

//   // ===== ADD THIS HANDLER FOR TIKTOK =====
//   const handleTikTokConnectionChange = (isConnected) => {
//     setShowTikTokMetrics(isConnected);
//   };

//   return (
//     <div className="owner-add-container">
//       <div className="card">
//         <h4 className="hdr hdr--primary hdr--lg">Integrations</h4>
//         <div className="card-body">
//           <form className="form">

//             <button type="button" className="btn btn-primary" onClick={connectViaSdk}>
//               Facebook/Instagram
//             </button>

//             <button type="button" onClick={connectToTwitter} className="btn btn-primary">
//               {loading ? 'Connecting to Twitter...' : 'Twitter'}
//             </button>

//             <button type="button" className="btn btn-primary" onClick={connectLinkedIn}>
//               LinkedIn
//             </button>

//             <button type="button" className="btn btn-primary" onClick={connectBluesky}>
//               Bluesky
//             </button>

//             {/* YouTube Integration */}
//             <YouTubeConnectButton tenantId={getTenantId()} />

//             {/* ===== ADD TIKTOK BUTTON HERE ===== */}
//             <div className="mb-3">
//               <TikTokConnectButton 
//                 tenantId={getTenantId()} 
//                 enableDirect={false}
//                 onConnectionChange={handleTikTokConnectionChange}
//               />
//             </div>

//             <button type="button" className="btn btn-secondary" disabled>
//               Empty
//             </button>

//             {/* Status message display */}
//             {statusMessage && <p className="status-message">{statusMessage}</p>}
//           </form>
//         </div>
//       </div>

//       {/* ===== ADD TIKTOK METRICS SECTION ===== */}
//       {showTikTokMetrics && (
//         <div className="mt-4">
//           <TikTokMetrics tenantId={getTenantId()} />
//         </div>
//       )}

//       <AppFooter
//         buttons={[
//           {
//             icon: <FaArrowLeft />,
//             label: "Back",
//             onClick: () => navigate(-1),
//           },
//           { icon: <FaHome />, label: 'Cancel', onClick: handleDashboard }
//         ]}
//       />
//     </div>
//   );
// }

// export default Integrations;


import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AppFooter from './AppFooter';
import { FaTimes, FaArrowLeft, FaHome } from 'react-icons/fa';
import { ensureFbSdk } from '../utils/ensureFbSdk';
import YouTubeConnectButton from './YouTubeConnectButton';
import TikTokConnectButton from './TikTokConnectButton';
import TikTokMetrics from './TikTokMetrics';
import globalErrorHandler from '../utils/globalErrorHandler';

const FB_APP_ID = '748347668239935';
const FB_VERSION = 'v24.0';

function Integrations() {
  const [statusMessage, setStatusMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [fbStatus, setFbStatus] = useState(null);
  const [showTikTokMetrics, setShowTikTokMetrics] = useState(false);

  const navigate = useNavigate();
  const { tenant } = useParams();
  const baseUrl = process.env.REACT_APP_BASE_URL || window.location.origin || 'http://localhost:5000';

  const getTenantId = () =>
    Number(tenant) || Number(localStorage.getItem('tenantId')) || 1;

  const handleDashboard = () => navigate(`/${getTenantId()}/dashboard`);

  // Initialize Facebook SDK
  useEffect(() => {
    (async () => {
      try {
        const FB = await ensureFbSdk(FB_APP_ID, FB_VERSION);
        FB.getLoginStatus((response) => setFbStatus(response));
      } catch (err) {
        console.error('Failed to init FB SDK', err);
        globalErrorHandler.logError(err, { component: 'Integrations - FB SDK Init' });
      }
    })();
  }, []);

  // Check for Twitter OAuth callback messages
  useEffect(() => {
    const handleTwitterCallback = (event) => {
      // Only accept messages from our domain
      if (event.origin !== window.location.origin && event.origin !== baseUrl.replace(/\/$/, '')) {
        return;
      }

      if (event.data?.type === 'TWITTER_OK') {
        setStatusMessage('✅ Twitter connected successfully');
        setLoading(false);
        console.log('[Twitter] Connection successful');
      } else if (event.data?.type === 'TWITTER_ERR') {
        const msg = event.data.error || 'Twitter authorization failed';
        setStatusMessage(`❌ ${msg}`);
        setLoading(false);
        console.error('[Twitter] Connection error:', event.data);
        globalErrorHandler.logError(
          new Error(msg),
          { 
            component: 'Twitter OAuth',
            errorData: event.data
          }
        );
      }
    };

    window.addEventListener('message', handleTwitterCallback);
    return () => window.removeEventListener('message', handleTwitterCallback);
  }, [baseUrl]);

  // ========== Twitter Connection (FIXED for iOS) ==========
  // const connectToTwitter = async () => {
  //   try {
  //     setLoading(true);
  //     setStatusMessage('Connecting to Twitter...');
      
  //     const tenantId = getTenantId();
      
  //     console.log('[Twitter] Starting OAuth flow...', {
  //       tenantId,
  //       baseUrl,
  //       isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
  //       isPWA: window.matchMedia('(display-mode: standalone)').matches,
  //       cookiesEnabled: navigator.cookieEnabled
  //     });

  //     // Log to server for debugging
  //     globalErrorHandler.logEvent({
  //       type: 'twitterAuthStart',
  //       tenantId,
  //       timestamp: new Date().toISOString()
  //     });

  //     // For iOS/Safari, use popup instead of redirect
  //     const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  //     const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
      
  //     if (isIOS || isSafari) {
  //       // Open in popup for better iOS compatibility
  //       const authUrl = `${baseUrl}/api/integrations/twitter/connect/${tenantId}`;
        
  //       console.log('[Twitter] Opening popup for iOS/Safari:', authUrl);
        
  //       const popup = window.open(
  //         authUrl,
  //         'twitter_oauth',
  //         'width=700,height=800,menubar=no,toolbar=no,status=no,left=200,top=100'
  //       );

  //       if (!popup) {
  //         throw new Error('Popup was blocked. Please allow popups for on-screen.app.');
  //       }

  //       popup.focus();

  //       // Poll for popup closure
  //       let pollInterval = setInterval(() => {
  //         if (popup.closed) {
  //           clearInterval(pollInterval);
  //           setLoading(false);
            
  //           // Check if we got a success message
  //           setTimeout(() => {
  //             if (!statusMessage.includes('✅')) {
  //               setStatusMessage('Twitter window closed. Please try again if not connected.');
  //             }
  //           }, 1000);
  //         }
  //       }, 500);

  //     } else {
  //       // Desktop: use full redirect
  //       const redirectUrl = `${baseUrl}/api/integrations/twitter/connect/${tenantId}`;
  //       console.log('[Twitter] Redirecting (desktop):', redirectUrl);
  //       window.location.href = redirectUrl;
  //     }

  //   } catch (err) {
  //     console.error('❌ Twitter integration failed:', err);
  //     setStatusMessage(`❌ ${err.message || 'Twitter connection failed. Please try again.'}`);
  //     setLoading(false);
      
  //     globalErrorHandler.logError(err, {
  //       component: 'Twitter OAuth - Start',
  //       tenantId: getTenantId()
  //     });
  //   }
  // };

  const connectToTwitter = async () => {
    try {
      setLoading(true);
      setStatusMessage('Connecting to Twitter...');
      
      const tenantId = getTenantId();
      const authUrl = `${baseUrl}/api/integrations/twitter/connect/${tenantId}`;
      
      console.log('[Twitter] Opening popup window:', authUrl);
      
      // Open in popup like Facebook/YouTube do
      const popup = window.open(
        authUrl,
        'twitter_oauth',
        'width=700,height=800,menubar=no,toolbar=no,status=no'
      );

      if (!popup) {
        throw new Error('Popup was blocked. Please allow popups for on-screen.app.');
      }

      popup.focus();

      // Poll for popup closure
      const pollInterval = setInterval(() => {
        try {
          if (popup.closed) {
            clearInterval(pollInterval);
            setLoading(false);
            
            // Check connection status after popup closes
            setTimeout(async () => {
              try {
                const statusRes = await fetch(`${baseUrl}/api/integrations/twitter/status/${tenantId}`);
                const statusData = await statusRes.json();
                
                if (statusData.connected) {
                  setStatusMessage('✅ Twitter connected successfully');
                } else {
                  setStatusMessage('Twitter window closed. Please try again if not connected.');
                }
              } catch (err) {
                console.error('Failed to check Twitter status:', err);
                setStatusMessage('Please refresh to see if Twitter connected.');
              }
            }, 1000);
          }
        } catch (err) {
          // Popup might be on different origin, can't check .closed
          console.log('Cannot access popup (probably on Twitter.com)');
        }
      }, 500);
      
    } catch (err) {
      console.error('❌ Twitter integration failed:', err);
      setStatusMessage(`❌ ${err.message || 'Error connecting to Twitter. Please try again.'}`);
      setLoading(false);
    }
  };

  // ========== Facebook Connection ==========
  async function peekEligibility(tenantId) {
    try {
      const peekRes = await fetch(`${baseUrl}/api/integrations/facebook/peek?tenantId=${tenantId}`);
      const peek = await peekRes.json();
      const pageCount = Array.isArray(peek?.pages) ? peek.pages.length : 0;

      setStatusMessage(
        pageCount > 0
          ? '✅ Facebook/Instagram connected'
          : 'Connected to Facebook, but no eligible Pages found. Ensure your IG is Business/Creator, linked to a Page, and you have Full control.'
      );
    } catch (e) {
      console.error('peek error', e);
      setStatusMessage('Connected, but could not verify eligibility. Check console.');
      globalErrorHandler.logError(e, { component: 'Facebook Peek' });
    }
  }

  const connectViaSdk = async () => {
    try {
      const FB = await ensureFbSdk(FB_APP_ID, FB_VERSION);

      if (!FB || typeof FB.login !== 'function') {
        throw new Error('FB SDK not ready (missing FB.login)');
      }

      FB.login(
        function (resp) {
          if (!resp || resp.status !== 'connected' || !resp.authResponse) {
            setStatusMessage('Facebook login was cancelled or not authorized.');
            return;
          }

          (async () => {
            try {
              const tenantId = getTenantId();
              const accessToken = resp.authResponse.accessToken;

              const r = await fetch(`${baseUrl}/api/integrations/facebook/token-login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ tenantId, accessToken }),
              });
              const j = await r.json();

              if (!r.ok || !j.success) {
                setStatusMessage(`❌ ${j.error || 'Facebook login failed'}`);
                return;
              }

              const immediateEligible = Array.isArray(j.pages)
                ? j.pages.some(p => p.igUserId && (p.hasPageToken ?? true))
                : false;

              if (immediateEligible) {
                setStatusMessage('✅ Facebook/Instagram connected');
              } else {
                await peekEligibility(tenantId);
              }
            } catch (e) {
              console.error('token-login error', e);
              setStatusMessage('❌ Failed to complete Facebook login.');
              globalErrorHandler.logError(e, { component: 'Facebook Token Login' });
            }
          })();
        },
        {
          scope: [
            'public_profile',
            'email',
            'pages_show_list',
            'pages_read_engagement',
            'pages_manage_metadata',
            'instagram_basic',
            'instagram_manage_comments',
            'instagram_manage_insights',
            'instagram_content_publish',
            'business_management'
          ].join(','),
          auth_type: 'rerequest',
          return_scopes: true,
        }
      );
    } catch (err) {
      console.error('FB.login failed to start', err);
      setStatusMessage('❌ Could not start Facebook login. Check SDK settings.');
      globalErrorHandler.logError(err, { component: 'Facebook SDK Login' });
    }
  };

  const connectInstagram = (e) => {
    e?.preventDefault();
    const tenantId = getTenantId();
    const url = `${baseUrl}/api/integrations/facebook/login?tenantId=${encodeURIComponent(tenantId)}`;
    const w = window.open(
      url,
      'fb_ig_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );

    if (!w) {
      setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    w.focus?.();

    let closedPoll = null;

    const cleanup = () => {
      window.removeEventListener('message', onMsg);
      if (closedPoll) {
        clearInterval(closedPoll);
        closedPoll = null;
      }
    };

    const onMsg = async (ev) => {
      if (!ev?.data) return;

      if (ev.data.type === 'FB_OK') {
        cleanup();
        await peekEligibility(tenantId);
      } else if (ev.data.type === 'FB_ERR') {
        cleanup();
        const msg = ev.data.error_message || ev.data.error || 'Facebook login failed';
        setStatusMessage(`❌ ${msg}`);
        console.error('FB_ERR from popup:', ev.data);
      }
    };

    window.addEventListener('message', onMsg);

    closedPoll = setInterval(async () => {
      if (w.closed) {
        cleanup();
        await peekEligibility(tenantId);
      }
    }, 800);
  };

  // ========== LinkedIn Connection ==========
  const connectLinkedIn = () => {
    const tenantId = getTenantId();
    const url = `${baseUrl}/api/integrations/linkedin/login?tenantId=${encodeURIComponent(tenantId)}`;
    
    const w = window.open(
      url,
      'li_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );
    
    if (!w) {
      setStatusMessage('❌ Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    
    w.focus?.();

    const onMsg = (ev) => {
      if (!ev?.data) return;
      
      if (ev.data.type === 'LI_OK') {
        window.removeEventListener('message', onMsg);
        setStatusMessage('✅ LinkedIn connected');
        console.log('[LinkedIn] Connection successful for tenant:', ev.data.tenantId);
      } else if (ev.data.type === 'LI_ERR') {
        window.removeEventListener('message', onMsg);
        const msg = ev.data.error_description || ev.data.error || 'LinkedIn login failed';
        setStatusMessage(`❌ LinkedIn: ${msg}`);
        console.error('[LinkedIn] Connection error:', ev.data);
      }
    };
    
    window.addEventListener('message', onMsg);
  };

  // ========== Bluesky Connection ==========
  const connectBluesky = () => {
    const meTenant = getTenantId();
    const url = `${baseUrl}/api/integrations/bluesky/login?tenantId=${encodeURIComponent(meTenant)}`;
    const w = window.open(
      url,
      'bsky_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );
    if (!w) {
      setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    w.focus?.();

    const onMsg = (ev) => {
      if (!ev?.data) return;
      if (ev.data.type === 'BSKY_OK') {
        window.removeEventListener('message', onMsg);
        setStatusMessage('✅ Bluesky connected');
      } else if (ev.data.type === 'BSKY_ERR') {
        window.removeEventListener('message', onMsg);
        const msg = ev.data.error_message || ev.data.error || 'Bluesky login failed';
        setStatusMessage(`❌ ${msg}`);
        console.error('BSKY_ERR from popup:', ev.data);
      }
    };
    window.addEventListener('message', onMsg);
  };

  const handleTikTokConnectionChange = (isConnected) => {
    setShowTikTokMetrics(isConnected);
  };

  return (
    <div className="owner-add-container">
      <div className="card">
        <h4 className="hdr hdr--primary hdr--lg">Integrations</h4>
        <div className="card-body">
          <form className="form">

            <button type="button" className="btn btn-primary" onClick={connectViaSdk}>
              Facebook/Instagram
            </button>

            <button 
              type="button" 
              onClick={connectToTwitter} 
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Connecting to Twitter...' : 'Twitter'}
            </button>

            <button type="button" className="btn btn-primary" onClick={connectLinkedIn}>
              LinkedIn
            </button>

            <button type="button" className="btn btn-primary" onClick={connectBluesky}>
              Bluesky
            </button>

            <YouTubeConnectButton tenantId={getTenantId()} />

            <div className="mb-3">
              <TikTokConnectButton 
                tenantId={getTenantId()} 
                enableDirect={false}
                onConnectionChange={handleTikTokConnectionChange}
              />
            </div>

            <button type="button" className="btn btn-secondary" disabled>
              Empty
            </button>

            {statusMessage && <p className="status-message">{statusMessage}</p>}
          </form>
        </div>
      </div>

      {showTikTokMetrics && (
        <div className="mt-4">
          <TikTokMetrics tenantId={getTenantId()} />
        </div>
      )}

      <AppFooter
        buttons={[
          {
            icon: <FaArrowLeft />,
            label: "Back",
            onClick: () => navigate(-1),
          },
          { icon: <FaHome />, label: 'Home', onClick: handleDashboard }
        ]}
      />
    </div>
  );
}

export default Integrations;